import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/additionalDrivers';

import { sendInvite } from './utils';

export default function* listenSendInvite() {
  yield takeEvery(actions.sendInvite.toString(), sendInvite);
}
